import { SupportRequest } from '@/app/entities/SupportRequest'
import { httpClient } from '../http/httpClient'

export const assignSupportRequest = async (number: string, userId?: string) => {
  const { data } = await httpClient.post<SupportRequest>(
    `/support-requests/${number}/assign`,
    { userId },
  )
  return data
}
